import React, { useState, useEffect } from 'react';

import { getCMSHomepageGrid } from '@/api/cms';
import { getOrFetchHeaderData } from '@/utils/headerCalls';
import NoDeliveryPage from '@/components/NoDeliveryPage/NoDeliveryPage';
import { getOrFetchConfiguration } from '@/utils/getConfiguration';
import LoginLayout from '@/components/LoginLayout/LoginLayout';
import { getLayoutProps } from '@/utils/layout/layout';
import useDeliveryServices from '@/hooks/useDeliveryServices';

export default function NoDelivery({ logo, loginConfig, loginImage, responsiveLogo }) {
  const [config, setConfig] = useState();
  loginImage === '' ? (loginConfig = 0) : null;
  const { getOrFetchDeliveryServices } = useDeliveryServices();

  useEffect(() => {
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
      return;
    }
    getOrFetchDeliveryServices();
    getConfiguration();
  }, []);
  return (
    <>
      {config && (
        <LoginLayout type={loginConfig} image={loginImage} responsiveLogo={responsiveLogo}>
          <NoDeliveryPage logo={logo} />
        </LoginLayout>
      )}
    </>
  );
}

export async function getStaticProps(context) {
  const { responsiveLogo } = await getLayoutProps({ headerProps: { selectedIndex: 0 } }, context.locale);

  const [{ data: logoData }, { data: loginAllData }] = await Promise.all([
    getCMSHomepageGrid('header_logo', context.locale),
    getOrFetchHeaderData('login_page', context.locale),
  ]);
  const logo = logoData.data[0].content.logo.url;
  const loginConfig = loginAllData.data[0].content.configuration;
  const loginImage = loginAllData.data[0].content.image?.url ? loginAllData.data[0].content.image?.url : '';

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
    login_register: (await import(`../../../prebuild-data/i18n/${context.locale}/login_register.json`)).default,
  };

  return {
    props: {
      responsiveLogo,
      logo,
      loginConfig,
      loginImage,
      messages,
    },
  };
}
